'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { elevarBaseData } from '@/lib/elevar/cart-events';
import { useCart } from '../commerce/cart/cart-context';
import { elevarViewItemList } from '@/lib/elevar/item-view-list';

export default function ElevarCollection({ cardProducts, slug }) {
  const { cart, cartReady } = useCart();
  const pathname = usePathname();
  const lastFiredPath = useRef(null);

  useEffect(() => {
    if (!cartReady || lastFiredPath.current === pathname) return;
    lastFiredPath.current = pathname;
    (async () => {
      if (window.ElevarDataLayer?.length > 1) {
        await window.ElevarInvalidateContext?.();
      }
      await elevarBaseData(cart);
      sessionStorage.setItem('referringCollection', `/collections/${slug}`);
      elevarViewItemList(cardProducts, slug);
    })();
  }, [cartReady, cart, pathname, slug, cardProducts]);

  useEffect(() => {
    return () => {
      lastFiredPath.current = null;
    };
  }, [pathname]);

  return null;
}
